import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getPageById } from './services/wordpressService';

const PageSingle = () => {
  const { id } = useParams();
  const [page, setPage] = useState(null);

  useEffect(() => {
    const fetchPage = async () => {
      const data = await getPageById(id);
      setPage(data);
    };
    fetchPage();
  }, [id]);

  if (!page) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container mx-auto mt-8">
      <h1 className="text-3xl font-bold">{page.title.rendered}</h1>
      <div dangerouslySetInnerHTML={{ __html: page.content.rendered }} className="prose max-w-full mt-4"></div>
    </div>
  );
};

export default PageSingle;
